import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'

class IgmpSnoopStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      igmpsnooping: null,
      error: false,
      loading: true
    }
  }
  componentDidMount () {
    this.setState({loading: true})
    this.setData(this.props.igmpsnooping, this.props.errors)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true, igmpsnooping: null})
    this.setData(props.igmpsnooping, props.errors)
  }
  async setData (igmpsnooping, err) {
    if (!igmpsnooping && !err.error) return
    if (err.error) return this.setState({error: err, loading: false})
    this.setState({ igmpsnooping: igmpsnooping, loading: false, error: false })
  }
  reload () {
    this.setState({loading: true})
    this.props.reload()
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='IGMP-Snooping' icon='globe' buttons={[{ icon: 'fa-refresh', event: () => this.reload() }]}>
        {this.state.igmpsnooping &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass paginatable={10} data={this.state.igmpsnooping.map(snoop => [
              snoop.multicast,
              snoop.timestamp,
              snoop.counter
            ])}>
              <tr>
                <th>Multicast</th>
                <th>Timestamp</th>
                <th>Counter</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching IGMP-Snooping {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default IgmpSnoopStatus



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/troubleshooting/IgmpSnoopStatus.js